const menuItems =
  ["syt", "sg_log"].includes(process.env.REACT_APP_CLIENT)
    ? ["Master Files", "Modules", "Reports", "Utility"]
    : ["Master Files", "Modules", "Reports", "Accounting", "Utility"];

export { menuItems };
